<template>
  <div class="modal default-modal auth-modal modal-open pos-fixed">
    <div class="table">
      <div class="table-cell">
        <div class="modal-container">
          <a href="" class="close" @click.prevent="closeModal">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="15.5" stroke="white" />
              <path
                d="M23.1719 10.4219C23.5938 10 23.5938 9.29688 23.1719 8.875C22.7031 8.40625 22 8.40625 21.5781 8.875L16 14.4531L10.4219 8.82812C9.95312 8.40625 9.25 8.40625 8.82812 8.82812C8.35938 9.29688 8.35938 10 8.82812 10.4219L14.4062 16L8.82812 21.5781C8.35938 22.0469 8.35938 22.75 8.82812 23.1719C9.25 23.6406 9.95312 23.6406 10.375 23.1719L15.9531 17.5938L21.5781 23.1719C22 23.6406 22.7031 23.6406 23.125 23.1719C23.5938 22.75 23.5938 22.0469 23.125 21.625L17.5469 16.0469L23.1719 10.4219Z"
                fill="white"
              />
            </svg>
          </a>

          <!-- <div class="modal-content" v-click-outside="closeModal"> -->
          <div class="modal-content" >
            <h2>{{ $t("user.authorization") }}</h2>
            <p class="margin-top">{{ $t("user.authorization_info") }}</p>
            <form method="post" enctype="multipart/form-data">
              <div class="field-row">
                <label for="name">{{ $t("user.first_name") }}</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  :class="{ is_invalid: errors }"
                  v-model="user.firstName"
                />
              </div>

              <div class="field-row">
                <label for="sirname">{{ $t("user.last_name") }}</label>
                <input
                  type="text"
                  name="sirname"
                  id="sirname"
                  :class="{ is_invalid: errors }"
                  v-model="user.lastName"
                />
              </div>

              <div class="field-row">
                <label for="seat">{{ $t("user.seat") }}</label>
                <input
                  type="text"
                  name="seat"
                  id="seat"
                  :class="{ is_invalid: errors }"
                  v-model="user.seat"
                />
              </div>
              <div class="field-row" v-if="errors">
                <label style="color: red">{{ $t("user.error") }}</label>
              </div>

              <div class="buttons">
                <input
                  type="submit"
                  name="enter"
                  :value="$t('user.login')"
                  @click.prevent="submit"
                />
              </div>

              <p class="legal" v-html="$t('user.login_policy')"></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import events from "@/mixins/events";

export default {
  name: "Login",
  mixins: [events],
  data: () => {
    return {
      user: {
        firstName: "",
        lastName: "",
        seat: "",
      },
      errors: false,
    };
  },
  computed: {
    ...mapState("user", {
      authenticate: (state) => state.authenticate,
    }),
  },
  methods: {
    ...mapActions("user", {
      loginAction: "loginUser",
    }),
    ...mapMutations("user", {
      setUserEntity: "SET_ENTITY",
    }),
    closeModal() {
      this.setUserEntity(["showModal", false]);
    },
    async submit() {
      await this.loginAction(this.user);
      this.errors = !this.authenticate;
      if (this.authenticate) {
        this._loginEvent();
      }
    },
  },
};
</script>

<style scoped>
.modal.default-modal.auth-modal.modal-open {
  z-index: 11002;
}
</style>
